import React from 'react'
import "./CommentCard.css"
import EmptyCardImage from "../assests/empty-user.webp";

export default function CommentCard() {
  return (
    <div className="comment-card">
      <div className="comment-card-userimg">
        <img src={EmptyCardImage} alt="img" />
      </div>
      <div>
        <p className="comment-card-username">username</p>
        <p className="comment-card-description">
          Comment and like features are still in development.
        </p>
      </div>
    </div>
  );
}
